<template>
  <div class="multi-image-preview">
    <el-dialog :show-close="false" :close-on-click-modal="false" top="50%" v-model="multiImagePreviewOpen" :close-on-press-escape="false">
      <div class="image-preview-box" v-if="multiImagePreviewOpen">
        <div class="image-preview-top">
          <div @click="newTabPreviewIamge()">
            <img src="../../assets/imgs/multi-image-preview/icon-magnifier.png">
            查看大图
          </div>
          <img class="close" src="../../assets/imgs/multi-image-preview/icon-close.png" @click="cancel()">
        </div>
        <div class="image-preview-middle">
          <img class="icon-big" :class="{'disabled-switch': currentImageIndex === 0}" src="../../assets/imgs/multi-image-preview/icon-left-big.png" @click="switchImage(-1)">
          <div class="image-big">
            <img :src="multiImageArray[currentImageIndex]">
          </div>
          <img class="icon-big" :class="{'disabled-switch': currentImageIndex === multiImageArray.length - 1}" src="../../assets/imgs/multi-image-preview/icon-right-big.png" @click="switchImage(1)">
        </div>
        <div class="image-preview-bottom">
          <img class="icon-small" :class="{'disabled-switch': previousGroup}" src="../../assets/imgs/multi-image-preview/icon-left-small.png" @click="switchGroup(-1)">
          <div class="image-list">
            <div class="image-group" :style="{'left': imageGroupMove + 'px'}">
              <div class="image-item" :class="{'select-image': index === currentImageIndex}" v-for="(item, index) in multiImageArray" :key="index" @click="switchImage(index, true)">
                <img :src="item">
              </div>
            </div>
          </div>
          <img class="icon-small" :class="{'disabled-switch': nextGroup}" src="../../assets/imgs/multi-image-preview/icon-right-small.png" @click="switchGroup(1)">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'multiImagePreview',
  model: {
    prop: 'multiImagePreviewOpen',
    event: 'input',
  },
  props: {
    multiImagePreviewOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
    multiImageArray: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
  },
  data() {
    return {
      currentImageIndex: 0,
      currentGroupIndex: 0,
      previousGroup: false,
      nextGroup: false,
      imageGroupMove: 0,
    };
  },
  methods: {
    cancel() {
      // 关闭弹窗前重置数据
      this.currentImageIndex = 0;
      this.currentGroupIndex = 0;
      this.previousGroup = false;
      this.nextGroup = false;
      this.imageGroupMove = 0;
      this.switchGroup();
      this.$emit('input', false);
    },
    newTabPreviewIamge() {
      window.open(this.multiImageArray[this.currentImageIndex]);
    },
    switchImage(previousOrNext, jump) {
      if (jump) {
        this.currentImageIndex = previousOrNext;
      } else {
        this.currentImageIndex = this.currentImageIndex + previousOrNext;
        if (this.currentImageIndex > this.multiImageArray.length - 1) {
          this.currentImageIndex = this.multiImageArray.length - 1;
        }
        if (this.currentImageIndex < 0) {
          this.currentImageIndex = 0;
        }
      }
    },
    switchGroup(previousOrNext) {
      // this.previousGroup = this.nextGroup = false;
      // 每组 9 张图片
      if (this.multiImageArray.length <= 9) {
        this.previousGroup = this.nextGroup = true;
      } else {
        const maxGroupIndex = Math.floor(this.multiImageArray.length / 9);
        this.currentGroupIndex = this.currentGroupIndex + previousOrNext;
        if (this.currentGroupIndex >= maxGroupIndex) {
          this.currentGroupIndex = maxGroupIndex;
          this.nextGroup = true;
        }
        if (this.currentGroupIndex <= 0) {
          this.currentGroupIndex = 0;
          this.previousGroup = true;
        }
      }
      this.imageGroupMove = -900 * this.currentGroupIndex;
    },
  },
  watch: {

  },
  created() {
    this.switchGroup();
  },
};
</script>

<style lang="less">
.multi-image-preview {
  img {
    outline: none;
  }
  .el-dialog__wrapper {
    background:rgba(0,0,0,0.4);
    .el-dialog {
      width: 1000px;
      height: 720px;
      background:rgba(17,17,17,0.7);
      border-radius:4px;
      transform: translate(-50%, -50%);
      margin: 0;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
  .image-preview-box {
    .image-preview-top {
      height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      div {
        outline: none;
        font-size: 14px;
        color: #FFFFFF;
        width:98px;
        height:36px;
        background:rgba(102,102,102,0.3);
        border-radius:4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 28px;
        cursor: pointer;
        &:hover {
          background:rgba(102,102,102,0.6);
        }
        img {
          width: 13px;
          height: 13px;
          margin-right: 5px;
        }
      }
      img.close {
        width: 30px;
        height: 30px;
        margin-right: 15px;
        cursor: pointer;
      }
    }
    .image-preview-middle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px 20px 40px;
      img.icon-big {
        width: 60px;
        height: 60px;
        cursor: pointer;
      }
      img.disabled-switch {
        opacity: 0.3;
        cursor: not-allowed;
      }
      div.image-big {
        height: 520px;
        display: flex;
        align-items: center;
        img {
          max-width: 750px;
          max-height: 520px;
        }
      }
    }
    .image-preview-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      img.icon-small {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
      img.disabled-switch {
        opacity: 0.3;
        cursor: not-allowed;
      }
      div.image-list {
        width: 895px;
        height: 80px;
        margin-left: 20px;
        overflow: hidden;
        position: relative;
        div.image-group {
          display: inline-flex;
          position: absolute;
          top: 0;
          left: 0;
          transition: ease-in-out 0.5s;
          div.image-item {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            box-sizing: border-box;
            position: relative;
            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              background:rgba(0,0,0,0.4);
            }
          }
          div.select-image {
            border-radius:1px;
            border:3px solid rgba(63,162,240,1);
            &::after {
              display: none;
            }
          }
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/multi-image-preview.vue